import {
  CoolingMaintenanceSituations,
} from 'sigma-mappings';
import {
  getInitialDate,
  getStartOfDay,
} from '@/services/dateTime/datetimeService';
import { timezones } from '@/constants/localizer';

const minimumDate = getInitialDate({ timeZone: timezones.SYSTEM_DATE_ONLY });
const currentDate = getStartOfDay({ timeZone: timezones.SYSTEM_DATE_ONLY });

const groupFields = (isUpdating, situation) => ({
  situation: {
    label: null,
    required: true,
    visible: !isUpdating,
  },
  description: {
    label: 'fields.engineering.cooling-maintenance.description',
    required: true,
    maxLength: 12,
  },
  associatedContact: {
    label: 'fields.engineering.cooling-maintenance.associated-contact',
    required: true,
  },
  advanceNoticeMaintenance: {
    label: 'fields.engineering.cooling-maintenance.advance-notice-maintenance',
    required: true,
    maxLength: 7,
    precision: 0,
    minValue: 1,
    maxValue: 999999,
  },
  operatingTimeMaintenance: {
    label: 'fields.engineering.cooling-maintenance.operating-time-maintenance',
    required: true,
    maxLength: 7,
    precision: 0,
    minValue: 1,
    maxValue: 999999,
  },
  installationDate: {
    label: 'fields.engineering.cooling-maintenance.installation-date',
    required: true,
    minValue: minimumDate,
    maxValue: currentDate,
  },
  operationEntryDate: {
    label: 'fields.engineering.cooling-maintenance.start-up-date',
    required: true,
    minValue: minimumDate,
    maxValue: currentDate,
  },
  lastMaintenanceDate: {
    label: 'fields.engineering.cooling-maintenance.last-maintenance-date',
    required: situation === CoolingMaintenanceSituations.USED,
    minValue: minimumDate,
    maxValue: currentDate,
    visible: !isUpdating && situation === CoolingMaintenanceSituations.USED,
  },
  totalOperationTime: {
    label: 'fields.engineering.cooling-maintenance.total-operating-time',
    required: isUpdating || situation === CoolingMaintenanceSituations.USED,
    maxLength: 7,
    precision: 0,
    minValue: 0,
    maxValue: 999999,
    visible: isUpdating || situation === CoolingMaintenanceSituations.USED,
  },
  timeSinceLastMaintenance: {
    label: 'fields.engineering.cooling-maintenance.time-since-last-maintenance',
    required: isUpdating || situation === CoolingMaintenanceSituations.USED,
    maxLength: 7,
    precision: 0,
    minValue: 0,
    maxValue: 999999,
    visible: isUpdating || situation === CoolingMaintenanceSituations.USED,
  },
  performedMaintenanceAmount: {
    label: 'fields.engineering.cooling-maintenance.performed-maintenance-amount',
    required: !isUpdating,
    maxLength: 7,
    precision: 0,
    minValue: 0,
    maxValue: 999999,
    visible: !isUpdating,
  },
});

export default groupFields;
